/**
 * Einstiegsseite der App (/welcome): Botschaft je Einstieg, Chat, Konto-Feld, Karten.
 * Die Einstiege (direkt, c, d, e, h, meta, suche, login) wählt public-chat/entry.ts.
 */
const publicChatDE: Record<string, string> = {
  'entry.direkt.kick': 'KI-Agent für LinkedIn',
  'entry.direkt.h1a': 'Dein KI-Agent für ',
  'entry.direkt.h1em': 'Direct Search',
  'entry.direkt.h1b': ' auf LinkedIn.',
  'entry.direkt.greet':
    'Hallo! Ich finde passende Kandidaten oder Kunden auf LinkedIn, schreibe jedem persönlich und fasse nach. Bevor du dich registrierst: Erzähl mir, wen du suchst, dann sage ich dir ehrlich, ob ich dir Zeit spare.',
  'entry.direkt.placeholder': 'Wen suchst du gerade? Zum Beispiel: Vertriebsleiter in München',

  'entry.c.kick': 'Für Recruiter im Direct Search',
  'entry.c.h1a': 'Spar dir ',
  'entry.c.h1em': '35 Stunden',
  'entry.c.h1b': ' LinkedIn-Ansprache im Monat.',
  'entry.c.greet':
    'Hallo! So rechnet sich das bei einem typischen Recruiter (Beispielrechnung). Erzähl mir, wen du suchst, dann rechne ich es für deinen Fall durch.',
  'entry.c.placeholder': 'Wen suchst du gerade? Zum Beispiel: Java-Entwickler in Köln',

  'entry.d.kick': 'KI-Agent für LinkedIn',
  'entry.d.h1a': 'KI-optimierte Automatisierung deiner ',
  'entry.d.h1em': 'LinkedIn-Ansprache',
  'entry.d.h1b': '.',
  'entry.d.greet':
    'Hallo! Ich finde Profile, bewerte jedes gegen deine Stelle, schreibe persönlich und fasse nach. Erzähl mir, wen du suchst, dann zeige ich dir, wie das bei dir aussähe.',
  'entry.d.placeholder': 'Wen suchst du gerade?',

  'entry.e.kick': 'Direct Search auf LinkedIn',
  'entry.e.h1a': 'Kandidaten ansprechen, ',
  'entry.e.h1em': 'ohne Copy-Paste',
  'entry.e.h1b': '.',
  'entry.e.greet':
    'Hallo! Ich schreibe jedem Kandidaten eine eigene Nachricht, keinen Serienbrief, und fasse nach. Du bekommst die Antworten. Erzähl mir, wen du suchst.',
  'entry.e.placeholder': 'Wen suchst du gerade?',

  'entry.h.kick': 'Für Headhunter und Personalberater',
  'entry.h.h1a': 'Direct Search für Headhunter, ',
  'entry.h.h1em': 'ohne Fleißarbeit',
  'entry.h.h1b': '.',
  'entry.h.greet':
    'Hallo! Ich übernehme Suche, Bewertung, Ansprache und Nachfassen auf LinkedIn, für mehrere Stellen parallel. Du führst die Gespräche. Woran arbeitest du gerade?',
  'entry.h.placeholder': 'Welches Mandat besetzt du gerade?',

  'entry.meta.kick': 'KI-Agent für LinkedIn',
  'entry.meta.h1a': 'Deine LinkedIn-Ansprache, ',
  'entry.meta.h1em': 'automatisch und persönlich',
  'entry.meta.h1b': '.',
  'entry.meta.greet':
    'Hallo! Ich suche passende Kandidaten auf LinkedIn, bewerte jedes Profil, schreibe jedem eine eigene Nachricht und fasse nach. Erzähl mir, wen du suchst, dann sage ich dir ehrlich, ob ich dir Zeit spare.',
  'entry.meta.placeholder': 'Wen suchst du gerade? Zum Beispiel: Pflegekräfte in Hamburg',

  'entry.suche.kick': 'Active Sourcing auf LinkedIn',
  'entry.suche.kickTerm': 'Du hast nach „{{term}}“ gesucht',
  'entry.suche.h1a': '',
  'entry.suche.h1em': 'Active Sourcing',
  'entry.suche.h1b': ', das sich selbst erledigt.',
  'entry.suche.greet':
    'Hallo! Genau das mache ich: passende Kandidaten auf LinkedIn suchen, jedes Profil bewerten, persönlich ansprechen und nachfassen. Erzähl mir, wen du suchst.',
  'entry.suche.placeholder': 'Wen suchst du gerade?',

  'entry.login.kick': 'Willkommen zurück',
  'entry.login.h1a': 'Schön, dass du ',
  'entry.login.h1em': 'wieder da',
  'entry.login.h1b': ' bist.',
  'entry.login.greet':
    'Melde dich an, dann geht es dort weiter, wo du aufgehört hast. Noch kein Konto? Frag mich einfach, ob sich das für dich lohnt.',
  'entry.login.placeholder': 'Frag mich etwas, auch ohne Anmeldung',
  'entry.sessionExpired': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',

  'entry.sub': 'Frag den Agenten, ob sich das für dich lohnt. Er antwortet sofort und ehrlich, ohne Anmeldung.',
  'entry.agentName': 'Dein KI-Agent',
  'entry.online': 'online, antwortet sofort',
  'entry.restart': 'Von vorn',
  'entry.send': 'Frage senden',
  'entry.inputLabel': 'Deine Frage an den Agenten',
  'entry.chatLabel': 'Chat mit dem Agenten',

  'entry.chip.worth': 'Lohnt sich das für mich?',
  'entry.chip.how': 'Wie funktioniert das?',
  'entry.chip.price': 'Was kostet das?',
  'entry.chip.safety': 'Ist das sicher für mein LinkedIn-Konto?',
  'entry.chip.sales': 'Geht das auch für Vertrieb?',
  'entry.chip.login': 'Ich komme nicht in mein Konto',

  'entry.tabSignup': 'Registrieren',
  'entry.tabLogin': 'Anmelden',
  'entry.railSignupTitle': 'Schon überzeugt?',
  'entry.railLoginTitle': 'Anmelden',
  'entry.googleTrial': 'Mit Google 14 Tage testen',
  'entry.emailSignup': 'Mit E-Mail registrieren',
  'entry.orEmail': 'oder mit E-Mail',
  'entry.trust1': '14 Tage kostenlos, ohne Zahlungsdaten',
  'entry.trust2': 'Server in Deutschland, DSGVO-konform',
  'entry.trust3': 'Dein LinkedIn-Konto bleibt bei dir',
  'entry.paymentNote': 'Für den Test brauchst du keine Zahlungsdaten. Nach 14 Tagen entscheidest du, ob du die Lizenzen kaufst.',
  'entry.inlineSignupTitle': 'Dein Testzugang, 14 Tage kostenlos',
  'entry.stickyLine': '14 Tage kostenlos · ohne Zahlungsdaten',
  'entry.stickyCta': 'Jetzt testen',
  'entry.submitSignup': '14 Tage kostenlos testen',
  'entry.footerServer': 'Server in Deutschland · DSGVO-konform',
  'entry.imprint': 'Impressum',
  'entry.privacy': 'Datenschutz',
  'entry.terms': 'AGB',
  'entry.errExists': 'Für diese E-Mail-Adresse gibt es schon ein Konto. Melde dich bitte an.',
  'entry.errSignup': 'Das Konto konnte nicht angelegt werden. Bitte versuch es noch einmal.',
  'entry.errCredentials': 'E-Mail oder Passwort stimmen nicht.',
  'entry.errLogin': 'Die Anmeldung hat nicht geklappt. Bitte versuch es noch einmal.',
  'entry.toLogin': 'Schon ein Konto? Anmelden',
  'entry.toSignup': 'Noch kein Konto? Kostenlos registrieren',
  'entry.tagline': 'Dein vertraulicher KI-Agent für LinkedIn',
  'entry.toWebsite': 'Zur Website von Secret AI Agent',
  'entry.close': 'Schließen',

  'entry.savings.title': 'Direct Search pro Monat (Beispielrechnung)',
  'entry.savings.manual': 'Von Hand',
  'entry.savings.agent': 'Mit dem Agenten',
  'entry.savings.manualValue': '~ 40 Std.',
  'entry.savings.agentValue': '~ 5 Std.',
  'entry.savings.you': 'Du führst nur noch die Gespräche.',

  'entry.pricing.title': 'Preise',
  'entry.pricing.recruiting': 'Recruiting',
  'entry.pricing.sales': 'Vertrieb',
  'entry.pricing.bundle': 'Beides im Bundle',
  'entry.pricing.perMonth': 'im Monat zzgl. MwSt.',
  'entry.pricing.note': 'Eine Lizenz pro LinkedIn-Konto. Quartalsweise etwa 10 %, jährlich etwa 20 % günstiger. Die ersten 14 Tage sind kostenlos.',
  'entry.pricing.cta': '14 Tage kostenlos testen',

  'entry.safety.title': 'So schützt der Agent dein LinkedIn-Konto',
  'entry.safety.1': 'Eigene, feste IP-Adresse und ein eigenes Gerät für dein Konto. Die Anmeldung bestätigst du einmalig.',
  'entry.safety.2': 'Arbeitet nur in deinen Zeitfenstern und hält Tageslimits ein. Bei Warnsignalen von LinkedIn halbiert er sein Tempo für 14 Tage.',
  'entry.safety.3': 'Auf Wunsch geht keine Nachricht ohne deine Freigabe raus.',
  'entry.safety.4': 'Server in Deutschland (Falkenstein und Nürnberg).',
  'entry.safety.note': 'Eine Garantie gegen Einschränkungen durch LinkedIn kann kein Anbieter geben.',

  'entry.steps.title': 'So arbeitet der Agent',
  'entry.steps.1': 'Passende Profile auf LinkedIn finden',
  'entry.steps.2': 'Jedes Profil gegen deine Kriterien bewerten (A, B, C)',
  'entry.steps.3': 'Kontaktanfrage und persönliche Nachricht, auf Wunsch erst nach deiner Freigabe',
  'entry.steps.4': 'Automatisch nachfassen, Antworten landen in deiner Inbox',
};

export default publicChatDE;
